import {
    Component,
    Element,
    Host,
    h,
    Listen,
    Prop,
    State,
} from "@stencil/core";
import { debounce } from "../../utils/debounce";

@Component({
    tag: "ux-iws-marginal-column",
    styleUrl: "marginal-column.scss",
    shadow: false,
})
export class MarginalColumn {
    private baseClass: string = "ux-iws-marginal-column";

    @Element() host: HTMLUxIwsMarginalColumnElement;

    /** Label for the marginal column button */
    @Prop() buttonLabel: string = "";
    /** Defines the breakpoint where the marginal column is always visible */
    @Prop() breakpointActiveAlways: number = 1440;
    /** If set, the marginal column can be used for full-width templates with button and fix positioned content */
    @Prop() showButtonOnFullWidth: boolean = false;

    /** The current active state  */
    @State() isActive: boolean = false;
    /** Set when the screen is wider than `breakpointActiveAlways` */
    @State() isActiveAlways: boolean = false;

    @Listen("resize", { target: "window" })
    handleResize() {
        this.host.style.setProperty("--transition-duration", "0s");
        this.updateStateDebounced();
    }

    componentWillLoad() {
        this.updateState();
    }

    connectedCallback() {
        document.addEventListener("click", this.deactivate);
    }

    disconnectedCallback() {
        document.removeEventListener("click", this.deactivate);
    }

    private toggleActive = (e) => {
        e.stopPropagation();
        this.isActive = !this.isActive;
    };

    private deactivate = () => {
        this.isActive = false;
    };

    private updateState = () => {
        const viewportWidth = window.innerWidth;
        this.isActiveAlways = this.showButtonOnFullWidth
            ? false
            : viewportWidth >= this.breakpointActiveAlways;
        this.host.style.setProperty("--transition-duration", "0.5s");
    };

    private updateStateDebounced = debounce(this.updateState, 100);

    render() {
        const {
            baseClass,
            isActive,
            isActiveAlways,
            buttonLabel,
            toggleActive,
        } = this;

        return (
            <Host class={baseClass}>
                <div
                    class={{
                        [`${baseClass}__button`]: true,
                        "ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase":
                            true,
                        "is-active": isActive,
                        "is-hidden": isActiveAlways,
                    }}
                    role="button"
                    onClick={(e) => toggleActive(e)}
                >
                    <span class={`${baseClass}__label`}>{buttonLabel}</span>
                    <ux-icon name="chevron-down" weight="bold" size-s="16" />
                </div>
                <div
                    class={{
                        [`${baseClass}__content`]: true,
                        "is-active": isActive,
                        "is-active-always": isActiveAlways,
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <slot />
                </div>
            </Host>
        );
    }
}
